import React from "react";

export const InfoIcon = (props: any) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
            <path d="M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm1.28,15.4a.53.53,0,0,1-.14.39.6.6,0,0,1-.4.13H11.21c-.32,0-.49-.17-.49-.52V10a.61.61,0,0,1,.12-.37.44.44,0,0,1,.37-.15h1.53a.38.38,0,0,1,.17,0,.64.64,0,0,1,.18.1.55.55,0,0,1,.13.17.37.37,0,0,1,.06.21Zm0-9.5a.38.38,0,0,1,0,.17.81.81,0,0,1-.1.18.49.49,0,0,1-.38.2H11.21c-.32,0-.49-.18-.49-.55V6.6a.55.55,0,0,1,.12-.4.5.5,0,0,1,.37-.12h1.55a.58.58,0,0,1,.38.12.51.51,0,0,1,.14.4Z"/>
        </svg>
    )
}